// importando estilização do componente
import { useEffect, useState } from 'react'
import { Footer } from '../../shared/components/layout/footer/Footer'
import { FullCurso } from '../../shared/components/layout/FullCurso/FullCurso'
import { MiniCardCurso } from '../../shared/components/layout/miniCardCurso/MiniCardCurso'
import style from './Cursos.module.css'
import { Styled } from './Styled'
import { CoursesServices, ICourses } from '../../shared/Services/api/courses/courses.services'
import { useModal } from '../../shared/Contexts/Modal.context'
import { TrainingAreaServices, ITrainingArea } from '../../shared/Services/api/trainingArea/TrainingArea.services'
import { ContentsServices, IContent } from '../../shared/Services/api/contents/Contents.services'
import { Header } from '../../shared/components/layout/header/Header'

export const Cursos: React.FC = () => {

    const [AllCourses, setAllCourses] = useState<ICourses[]>([]);
    const [AllContents, setAllContents] = useState<IContent[]>([]);
    const [CoursesByTrainingArea, setCoursesByTrainingArea] = useState<ICourses[]>([]);
    const [TrainingAreaName, setTrainingAreaName] = useState<string | null>(null);
    const { TrainingAreaIdInDestak, setTrainingAreaIdInDestak } = useModal();
    const [searchTerm, setSearchTerm] = useState<string>('');

    // Buscando todos os conteúdos globais para permitir busca por conteúdo
    useEffect(() => {
        const fetchContents = async () => {
            try {
                const result = await ContentsServices.getAllContents();
                if (!(result instanceof Error)) {
                    setAllContents(result.data);
                }
            } catch (error) {
                console.error('Erro ao buscar conteúdos globais:', error);
            }
        };
        fetchContents();
    }, []);

    // Buscando todos os curos
    useEffect(() => {
        const fetchCourses = async () => {
            try {
                // usa o serviço para buscar no then  se erro ou sucesso
                const result = await CoursesServices.getAllCourses();
                console.log(result);
                if (!(result instanceof Error) && Array.isArray(result.data)) {
                    setAllCourses(result.data);
                } else {
                    setAllCourses([]);
                }
            } catch (error) {
                console.error('Erro ao buscar os cursos:', error);
            }
        };
        fetchCourses();
    }, [])

    // Buscando cursos por área de treinamento
    useEffect(() => {
        const fetchCoursesByTrainingArea = async () => {
            try {
                // usa o serviço para buscar no then  se erro ou sucesso
                if(!TrainingAreaIdInDestak) return;
                const result = await CoursesServices.getCoursesByTrainingAreaId(TrainingAreaIdInDestak);
                console.log(`TrainingCourses for TrainingAreaId ${TrainingAreaIdInDestak}:`, result);
                if (!(result instanceof Error) && Array.isArray(result.data)) {
                    setCoursesByTrainingArea(result.data);
                } else {
                    setCoursesByTrainingArea([]);
                }
            } catch (error) {
                console.error('Erro ao buscar os cursos:', error);
            }
        };
        fetchCoursesByTrainingArea();
    }, [TrainingAreaIdInDestak])

    // Buscando nome da área de treinamento
    useEffect(() => {
        const fetchTrainingAreaName = async () => {
            try {
                if(!TrainingAreaIdInDestak) {
                    setTrainingAreaName(null);
                    return;
                }
                const result = await TrainingAreaServices.getTrainingAreaById(TrainingAreaIdInDestak);
                if (!(result instanceof Error)) {
                    setTrainingAreaName(result.Name);
                } else {
                    setTrainingAreaName(null);
                }
            } catch (error) {
                console.error('Erro ao buscar nome da área de treinamento:', error);
            }
        };
        fetchTrainingAreaName();
    }, [TrainingAreaIdInDestak])

    const clearFilter = () => {
        setTrainingAreaIdInDestak(null);
        setTrainingAreaName(null);
    }

    const clickCursosPresenciais = () => {
        window.location.href = '/cursos';
    }
    const clickCursosOnline = () => {
        window.location.href = 'https://ead.ouromoderno.com.br';
    }

    const normalizeString = (str: any) => {
        if (!str || typeof str !== 'string') return "";
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    };

    const filteredCourses = (TrainingAreaIdInDestak ? CoursesByTrainingArea : AllCourses).filter(course => {
        if (!searchTerm) return true;
        
        const searchNorm = normalizeString(searchTerm);
        
        // Pesquisa no Nome
        if (course.Name && normalizeString(course.Name).includes(searchNorm)) return true;
        
        // Pesquisa na Descrição
        if (course.Description && normalizeString(course.Description).includes(searchNorm)) return true;
        
        // Pesquisa nos Conteúdos (Contents)
        if (course.Contents && Array.isArray(course.Contents)) {
            const hasContentMatch = course.Contents.some(contentItem => {
                // Caso o conteúdo seja um objeto populado
                if (contentItem && typeof contentItem === 'object' && contentItem.Name) {
                    return normalizeString(contentItem.Name).includes(searchNorm);
                }
                
                // Caso o conteúdo seja apenas um ID (string)
                if (typeof contentItem === 'string') {
                    const resolvedContent = AllContents.find(c => c._id === contentItem);
                    return resolvedContent && normalizeString(resolvedContent.Name).includes(searchNorm);
                }

                // Caso seja uma estrutura diferente { ContentId: string } como visto em interfaces
                const anyContent = contentItem as any;
                if (anyContent.ContentId) {
                    const resolvedContent = AllContents.find(c => c._id === anyContent.ContentId);
                    return resolvedContent && normalizeString(resolvedContent.Name).includes(searchNorm);
                }

                return false;
            });
            if (hasContentMatch) return true;
        }

        return false;
    });

    return (
        <Styled.Content>
            <Header />
            
            <div className="HeroSection">
                <h1>Nossos Cursos</h1>
                <p>Encontre a formação ideal para o seu futuro profissional com nossos cursos presenciais e online.</p>
            </div>

            <div className="SearchArea">
                <div className="SearchContainer">
                    <input 
                        type="text" 
                        placeholder="O que você quer aprender hoje?" 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button>Pesquisar</button>
                </div>
            </div>

            <div className="NavigationTabs">
                <span className="TabLink active" onClick={clickCursosPresenciais}>
                    Cursos Presenciais
                </span>
                <div className="Separator"></div>
                <span className="TabLink" onClick={clickCursosOnline}>
                    Cursos Online
                </span>
            </div>
            
            {TrainingAreaIdInDestak && TrainingAreaName && (
                <div className='FilterContainer'>
                    <span>Cursos na Área de {TrainingAreaName}</span>
                    <button 
                        onClick={clearFilter}
                        className='ClearFilterButton'
                    >
                        ×
                    </button>
                </div>
            )}

            <div className='AllCourses'>
                {filteredCourses.map((course) => (
                    <MiniCardCurso
                        key={course._id}
                        id={course._id}
                    />
                ))}
            </div>
            <Footer />
        </Styled.Content>
    )
}
// aqui estamos exportando nosso componente
